const templateTypes = ["Patient", "Caregiver"] as const;

export const templateTypePicker = templateTypes.map((type) => ({
  label: type,
  value: type,
}));

export type TypeTemplate = (typeof templateTypes)[number] | "Insurance";
